import React from 'react';
import {Outlet} from 'react-router-dom';
import AddElementsContextProvider from '../../context/AddElementsContext';
import {SlideErrorsProvider} from '../../context/SlideErrorsContext';
import {usePresentationSocket} from '../../utils/hooks/usePresentationSocket';
import EditNavbar from '../components/common/navbar/EditNavbar';
import TransitionWrapper from '../components/pageTransitions/PageTransitionWrapper';
import {RulesModalProvider} from '../context/RulesModalContext';
import {SetSlideUpdateProvider} from '../context/SetSlideUpdateContext';

function EditorLayout(): JSX.Element {
    usePresentationSocket();

    return (
        <SlideErrorsProvider>
            <SetSlideUpdateProvider>
                <RulesModalProvider>
                    <AddElementsContextProvider>
                        <div className="p-presEdit">
                            <main>
                                <EditNavbar />
                                <TransitionWrapper>
                                    <Outlet />
                                </TransitionWrapper>
                            </main>
                        </div>
                    </AddElementsContextProvider>
                </RulesModalProvider>
            </SetSlideUpdateProvider>
        </SlideErrorsProvider>
    );
}

export default EditorLayout;
